import React, { useEffect } from "react";
import Header from "./components/Header";
import Schedule from "./components/Schedule";
import Features from "./components/Features";
import Steps from "./components/Steps"
import LubProducts from "./components/LubProducts";
import ShellExperience from "./components/ShellExperience";
import FindLub from "./components/FindLub";
import ScheduleButton from "./components/ScheduleButton";
import BackToTopButton from "./components/BackToTopButton";
import KnowOilPrice from "./components/KnowOilPrice";
// import Services from "./components/Services";
import WelcomeModal from "../WelcomeModal/WelcomeModal";
import OilFAQs from "./components/OilFAQs";
import Promotions from "./components/Promotions";
import Footer from "./components/Footer";
import { config } from '../../config';

import "./styles.scss";
// Footer global ahora gestionado por App para evitar duplicado

const Landing = () => {
  useEffect(() => {
    let target = null;
    try { target = sessionStorage.getItem('landingScrollTarget'); } catch (e) {}
    if (!(target && target.startsWith('#'))) return; // ignoramos hash directo para no autoscroll sin intención
    if (target === '#__top') {
      window.scrollTo({ top: 0, behavior: 'auto' });
      try { sessionStorage.removeItem('landingScrollTarget'); } catch (e) {}
  // Eliminado replaceState para no afectar el historial
      return;
    }
    const attemptScroll = () => {
      const el = document.querySelector(target);
      if (!el) return false;
      const nav = document.querySelector('.navbar');
      const baseOffset = (nav ? nav.getBoundingClientRect().height : 0) + 28;
      let topNode = el;
      if (['#oil-products','#faq','#promotions'].includes(target)) {
        const heading = el.querySelector('h1,h2,h3,h4');
        if (heading) topNode = heading;
      }
      const extraOffset = (target === '#oil-products') ? 40 : (target === '#faq' ? 60 : (target === '#promotions' ? 60 : 0));
      let top = topNode.getBoundingClientRect().top + window.scrollY - (baseOffset + extraOffset);
      if (top < 0) top = 0;
      const maxScroll = document.documentElement.scrollHeight - window.innerHeight;
      if (top > maxScroll) top = maxScroll;
      window.scrollTo({ top, behavior: 'auto' });
      requestAnimationFrame(() => {
        const adj = topNode.getBoundingClientRect().top + window.scrollY - (baseOffset + extraOffset);
        if (Math.abs(adj - window.scrollY) > 4) {
          let bounded = adj;
            if (bounded < 0) bounded = 0;
            if (bounded > maxScroll) bounded = maxScroll;
          window.scrollTo({ top: bounded, behavior: 'smooth' });
        }
        // Verificación: si el título quedó muy arriba (<10px), aplica un pequeño ajuste extra
        const rect = topNode.getBoundingClientRect();
        if (rect.top < 10) {
          const finalTop = window.scrollY - 15; // baja un poco más
          if (finalTop >= 0) window.scrollTo({ top: finalTop, behavior: 'smooth' });
        }
      });
  try { sessionStorage.removeItem('landingScrollTarget'); } catch (e) {}
  // Eliminado replaceState para no afectar el historial
  return true;
    };
    let tries = 0;
  const maxTries = 20; // reduce intentos para menor carga (~1s)
    const loop = () => {
      if (attemptScroll()) return;
      tries += 1;
      if (tries < maxTries) setTimeout(loop, 50);
    };
    loop();
  }, []);
  return (
    <div className="landing">
      <Header />
      <div className="landing-content">
  <BackToTopButton />
  <ScheduleButton className="ml-auto" />
        <Schedule />
        <Features />
        <Steps />
    <LubProducts />
    {config.ENABLE_PROMOTIONS && <Promotions />}
    <ShellExperience />
  <OilFAQs />
        {/* <FindLub />
        <KnowOilPrice /> */}
        <Footer />
      </div>
      <WelcomeModal />
    </div>
  );
};

export default Landing;
